import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `SUPPORT_*` codes the case queue meets.
 *
 * **Never inline a backend code in JSX.** The code is a log key; the sentence is
 * what reaches the operator; the `X-Request-ID` stays in the log line.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  SUPPORT_SCOPE_REQUIRED: {
    message: 'قراءة طابور الحالات تحتاج دور مشغّل في الدعم، ولا يحمله حسابك.',
    tone: 'warning',
  },
  SUPPORT_FILTER_COLUMN_NOT_ALLOWED: {
    message: 'تعذّر ترتيب الطابور بهذه القيمة. أعد تحميل الصفحة.',
    tone: 'warning',
  },
  SUPPORT_UPSTREAM_FAILED: {
    message: 'الخدمة غير متاحة الآن. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
  SUPPORT_UPSTREAM_TIMEOUT: {
    message: 'تأخّرت الخدمة عن الردّ. أعد المحاولة بعد قليل.',
    tone: 'neutral',
  },
};
